import TitleBlock from '@anm/components/TitleBlock';
import Button from '@anm/components/buttons/Button';
import { OptionContainer, SelectOptionsContainer, SelectValueContainer } from '@anm/components/select/Select';
import { DEFAULT_WAVE_COLOR } from '@anm/constants/colors';
import getContrast from '@anm/helpers/color/getContrast';
import { flexCenter } from '@anm/styles/helpers';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 352px;
  display: flex;
  max-width: 100%;
  min-height: 400px;
  flex-direction: column;
  ${OptionContainer} > div > div {
    display: flex;
    align-items: center;
    flex-direction: row;
  }
  ${SelectOptionsContainer} {
    overflow: auto;
    max-height: 200px;
  }
  ${SelectValueContainer} {
    padding: 4px;
    min-height: 42px;
    box-sizing: border-box;
    & > div {
      display: flex;
      align-items: center;
      flex-direction: row;
    }
  }
`;

export const BrandLogosContainer = styled.div`
  margin: 28px -6.5px;
  width: calc(100% + 15px);
`;

export const Logo = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 5px;
  background: #f5f7fa;
  object-fit: contain;
  margin: 0 6.5px 13px;
  box-sizing: border-box;
  border: 1px solid rgba(1, 83, 130, 0.2);
`;

export const Title = styled(TitleBlock)`
  h1,
  h2,
  h3,
  h4 {
    font-size: 24px;
    line-height: 29px;
    text-align: center;
    margin-bottom: 28px;
  }
`;

export const ButtonWrapper = styled(Button)`
  margin: auto;
  margin-bottom: 0;
`;

export const BrandLogo = styled.div<{ color?: string }>`
  ${flexCenter};
  width: 32px;
  height: 32px;
  font-size: 14px;
  cursor: pointer;
  object-fit: contain;
  font-weight: 600;
  line-height: 42px;
  border-radius: 3px;
  margin-right: 10px;
  background: ${({ color }) => color};
  color: ${({ color = DEFAULT_WAVE_COLOR }) => (getContrast(color, '#fff') > 2 ? '#fff' : '#000')};
`;

export default Wrapper;
